var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile",attrs:{"id":("tile_" + _vm.id)}},[_c('img',{staticClass:"tile-image",attrs:{"src":_vm.getImg(_vm.value)},on:{"click":_vm.rotateAndCheck}})])}
var staticRenderFns = []

export { render, staticRenderFns }